import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/all';

jQuery.fn.extend({
	isInViewport: function() {
		if (jQuery(this).length === 0) return false;
		let elementTop = jQuery(this).offset().top;
		let elementBottom = elementTop + jQuery(this).outerHeight();

		let viewportTop = jQuery(window).scrollTop();
		let viewportBottom = viewportTop + jQuery(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	}
});

var showreel_vimeo;

// gsap.config({
//   autoSleep: 60,
//   force3D: false,
//   nullTargetWarn: false,
//   trialWarn: false,
//   units: { left: "%", top: "%", rotation: "rad" },
// });

// gsap.registerPlugin(ScrollTrigger);

jQuery(function($) {
	// openModal('.advanced-filters-overlay');

	// const panels = gsap.utils.toArray(".branding_services__cta_bg .scrolling-word");

	// console.log('GSAP', gsap);
	// // gsap.to(".branding_services__cta_bg", { rotation: 27, X: 100, duration: 1 });

	// const tl = gsap.timeline({
	// 	scrollTrigger: {
	// 		trigger: ".branding_services__cta_bg",
	// 		pin: false,
	// 		pinSpacing: true,
	// 		// anticipatePin: 1,
	// 		scrub: 1,
	// 		invalidateOnRefresh: true,
	// 		start: () => "-=" + (window.outerHeight - ($('.scrolling-words').outerHeight())),
	// 		end: () => "+=" + (window.outerHeight - ($('.scrolling-words').outerHeight())),
	// 		// markers: true
	// 	}
	// });

	// tl.to(panels, {
	// 	// x: () => -100 * (sections.length - 1),
	// 	yPercent: -100 * (panels.length - 1),
	// });

	var isCountingUp = false;

	if ($('.single-projects')) {
		$('.jask-image, .wp-block-image').each(function() {
			if ($(this).isInViewport()) {
				$(this).find('img, video').addClass('animate');
			}
		});
	}

	if ($('body').hasClass('page-template-template-dna')) {
		$('.do-animate').each(function() {
			if ($(this).isInViewport()) {
				$(this).addClass('animate');
			}
		});
	}

	$(window).on('resize scroll', function() {
		if (isCountingUp) return;
		if ($('.counter').isInViewport()) {
			isCountingUp = true;
			doCountup();
		}

		if ($('.single-projects')) {
			$('.jask-image, .wp-block-image').each(function() {
				if ($(this).isInViewport()) {
					$(this).find('img, video').addClass('animate');
				}
			});
		}

		if ($('body').hasClass('page-template-template-dna')) {
			$('.do-animate').each(function() {
				if ($(this).isInViewport()) {
					$(this).addClass('animate');
				}
			});
		}
	});

	function doCountup() {
		jQuery('.counter').each(function() {
			var $this = $(this),
				countTo = $this.attr('data-count'),
				suffix = $this.attr('data-suffix');
			$({
				countNum: $this.text()
			}).animate({
				countNum: countTo
			}, {
				duration: 800,
				easing: 'linear',
				step: function() {
					$this.text(Math.floor(this.countNum).toLocaleString() + (suffix ? suffix : ''));
				},
				complete: function() {
					$this.text(this.countNum.toLocaleString() + (suffix ? suffix : ''));
				}
			});
		});
	}

	// const myVivus = new Vivus('curly-wurly');
	// myVivus.stop().reset().play(2);

	// new Vivus('curly-wurly', {
	// 	duration: 100,
	// 	type: 'oneByOne',
	// 	animTimingFunction: Vivus.EASE,
	// }, function() {
	// 	$('#curly-wurly').find('path').css('fill', '#BABBBF');
	// });

	$('input[type=checkbox]').on('change', function() {
		$(this).parent().toggleClass('checked');
	});

	var inputs = $('input[type=text], input[type=email], input[type=tel], textarea');
	inputs.each(function() {
		var parent = $(this).closest('.gfield');
		var thisValue = $(this).val();
		if (thisValue) {
			$(parent).addClass('focus');
		}
	});

	inputs.on('focus', function() {
		var parent = $(this).closest('.gfield');
		$(parent).addClass('focus');
	});

	inputs.on('blur', function() {
		var parent = $(this).closest('.gfield');
		var thisValue = $(this).val();
		if (thisValue) {
			return;
		}

		parent.removeClass('focus');
	});

	$('[data-play-video]').on('click', function(e) {
		let video_id = $(this).attr('data-video-id');
	});

	if (window.location.hash && window.location.hash === '#showreel') {
		var options = {
			id: '889167241',
			width: '100%',
			playsinline: false,
			responsive: true,
			portrait: false,
			title: false,
			dnt: true,
			controls: false,
			autoplay: false
		};

		showreel_vimeo = new Vimeo.Player('showreel-popout', options);
		$('body').addClass('showreel-open');
		$('#showreel-popout').addClass('from-email');
	}

	$(window).on('resize', function() {
		if (window.innerWidth > 1024 && $('body').hasClass('showreel-open')) {
			showreel_vimeo.pause();
		}
	});

	$('.nav-open').on('click', function(e) {
		e.preventDefault();
		if ($('body').hasClass('showreel-open')) {
			$('body').removeClass('showreel-open');
			closeShowreel();
		} else {
			$('body').toggleClass('menu-open');
			$('.navigation').toggleClass('open');
		}
	});

	$('.nav-close').on('click', function(e) {
		e.preventDefault();
		$('body').removeClass('menu-open');
		$('.navigation').removeClass('open');
	});

	if ($('.services-scroller').length) {
		initServicesScroller($);
	}
});

function initServicesScroller($) {
	let options = $('.services-scroller > span').data('options').split(',');
	let index = 0;
	let li_item = $('.services-scroller > span > ul > li').first();
	let items_outer = $('.services-scroller > span > ul');
	let items = $('.services-scroller > span > ul > li');
	var bezierEasing = [0.71, 0, 0.42, 1.17];
	let current = items.get(0);

	// https://stackoverflow.com/a/6685414
	(function scroll() {
		items = $('.services-scroller > span > ul > li');
		current = items[0];
		let next = items[index + 1];

		if ($(next).text() !== 'create') {
			$(current).closest('h1').removeClass('green');
		} else {
			$(current).closest('h1').addClass('green');
		}

		let cur_margin = -98 // line-height = 88.5667px;
		items_outer.append('<li>' + $(current).text() + '</li>');
		$(current).css('margin-top', cur_margin);

		setTimeout(function() {
			$(current).remove();
			index--;
			index++;
		}, 1500);

		setTimeout(scroll, 2 * 1000);
	})();
}

jQuery(function($) {
	$('.content_projects').find('h3, h2').each(function() {
		let words = $(this).text().split(' ');
		let final = '';
		let last_words = [];

		for (let i = 0; i < words.length; i++) {
			if (i === words.length - 1) {
				last_words.push(words[i]);
			} else {
			}
		}

		for (const word in words) {
			// if word in last words array
			if (last_words.includes(words[word])) {
				final += ' <span class="underline">' + words[word] + '</span>';
			} else {
				final += ' ';
				final += words[word];
			}
		}

		$(this).html(final);
	});

	$('.modal-close').on('click', function(e) {
		e.preventDefault();
		// .removeClass('active');
		closeModal($(this).closest('.modal'));
	});

	$('.filter-open').on('click', function(e) {
		e.preventDefault();
		openModal('.advanced-filters-overlay');
	});

	// on click of any anchor tag
	// check if the first character of the href is a #
	// if true start a smooth scroll to the element on the page
	$('a[href^="#"]').on('click', function(e) {
		let disallowed_links = [
			'#showreel',
			'#play-showreel',
			'#play-video',
			'#close-video',
		]

		if (disallowed_links.includes($(this).attr('href'))) return;

		if (!$(this).parent().hasClass('showreel-menu-link')) {
			if (!$(this).parent().hasClass('menu-item-type-custom')) {
				e.preventDefault();
				var target = $(this).attr('href');
				if (target.charAt(0) === '#' && target !== '#' && !target.endsWith('showreel') && $(target).length) {
					$('html, body').animate({
						scrollTop: $(target).offset().top
					}, 1000);
				}
			} else {
				window.location.href = $(this).attr('href');
			}
			e.preventDefault();
		}
	});
	$('.showreel-menu-link a').bind('click', function(e) {

		if ($('body').hasClass('home') && !$('#showreel-popout').length) {
			$('.home_hero').after('<div id="showreel-popout"><div class="close"><a href="#" onclick="closeShowreel()">Close</a></div><a href="#" class="play" onclick="playModalShowreel()">Play</a></div>');
		}

		if ($('#showreel-popout').length) {
			var options = {
				id: '889167241',
				width: '100%',
				playsinline: false,
				responsive: true,
				portrait: false,
				title: false,
				dnt: true,
				controls: false,
				autoplay: false
			};

			showreel_vimeo = new Vimeo.Player('showreel-popout', options);
			$('body').addClass('showreel-open');
			$('#showreel-popout').addClass('from-email').removeClass('playing');
			return false;
		} else {
			window.location.href = $(this).attr('href');
		}
		e.preventDefault();
	});
});

jQuery(function($) {
	$('.random-icon').each(function() {
		let available_icons = [
			'cross-grid',
			'squiggle-grid'
		];

		let random_icon = available_icons[Math.floor(Math.random() * available_icons.length)];
		$(this).addClass(random_icon);
	});

	$('.sixty-forty-split').find('.right>h4').on('click', function() {
		$(this).parent().toggleClass('open');

		// if($(this).p˙rent().hasClass('open')) {
		// 	$(this).height($(this).parent().height());
		// } else {
		// 	$(this).height(0);
		// }
	});

	loadVideos();
	stopAllVideos(); // To avoid all videos playing on load (which shouldn't even be possible)

	$('.single-post_content').find('a').each(function() {
		$(this).attr('data-title', $(this).text());
	});
});

function stopAllVideos() {
	$('.cf-player').each(function(index, child) {
		console.log(index, child);
		if (child instanceof HTMLVideoElement) {
			$(child).attr('muted');
		}
	});
}

function loadVideos() {
	$('.cf-player').each(function(index, item) {
		console.log('Loading Cloudflare Videos');

		let video_id = $(item).attr('data-video-id');

		// console.log('Video ID', video_id);

		if ($(this).data('play-on') === 'open') {
			let target = $(this).attr('data-target');

			$(target).on('open', function() {
				let hls = new Hls();
				let video_hls_source = "https://videodelivery.net/" + video_id + "/manifest/video.m3u8";
				if (Hls.isSupported()) {
					hls.loadSource(video_hls_source);
					hls.attachMedia(item);
				} else if (item.canPlayType('application/vnd.apple.mpegURL')) {
					console.error('[3] HLS stream not supported')
					item.src = video_hls_source;
				}
			});

			return;
		}

		let hls = new Hls();
		let video_hls_source = "https://videodelivery.net/" + video_id + "/manifest/video.m3u8";
		if (Hls.isSupported()) {
			hls.loadSource(video_hls_source);
			hls.attachMedia(item);
			console.log('[1] HLS stream is supported')
		} else if (item.canPlayType('application/vnd.apple.mpegURL')) {
			console.error('[4] HLS stream not supported')
			item.src = video_hls_source;
			var playPromise = video.play();

			if (playPromise !== undefined) {
				playPromise.then(_ => {
					// Playback started
					console.log('Automatic playback started');
				}).catch(error => {
					// Could not begin playback automatically
					console.log('There was an error attempting automatic playback of video.');
					console.error(error);
				});
			}
		}
	});
}


function openModal(target) {
	jQuery('body').addClass('menu-open');
	jQuery(target).addClass('active');
}

function closeModal(target) {
	jQuery('body').removeClass('menu-open');
	jQuery(target).removeClass('active');
}
// Add target="_blank" to all anchor tags that don't start with the current domain name
jQuery(function($) {
	let site_domain = window.location.hostname;
	$('a').each(function() {
		if ($(this).attr('href').charAt(0) !== '#' && $(this).attr('href').charAt(0) !== '/') {
			if ($(this).hasClass('project_permalink')) return;
			let link_domain = $(this).attr('href').split('/')[2];

			if (link_domain !== site_domain) {
				$(this).attr('target', '_blank');
			}
		}
	});

	var click_count = 0;
	$('body').on('click', '.friends', function(e) {
		click_count++;
		if (click_count === 12) {
			$('.friends ul li:nth-child(1)').css({ "transform": "translateX(33%)" });
			$('.friends ul li:nth-child(3)').css({ "transform": "translateX(-33%)" });
			$('.friends').addClass('overlay-active');
			var audio = new Audio('https://www.jaskcreative.co.uk/content/themes/jask-creative/best-friends.mp3');
			audio.play();
		}
	});

	if ($('section.testimonials').length) {
		var testimonials = new Promise((resolve, reject) => {
			$.ajax({
				// call to WP api to get projects
				url: '/wp-json/jask-creative/v1/testimonials',
				data: '',
				success: function(data) {
					resolve(data);
				},
				error: function(data) {
					reject(data);
				}
			});
		});
		testimonials.then((data) => {

			shuffle(data);

			for (const testimonial of data) {
				var placeholder = $('.testimonial.placeholder:first');
				placeholder.removeClass('placeholder');
				placeholder.find('>p').remove();
				placeholder.prepend(testimonial.content);
				placeholder.find('cite').html(testimonial.cite);
				if (testimonial.role) {
					placeholder.find('.testimonial-footer p').html(testimonial.role);
				} else {
					placeholder.find('.testimonial-footer p').remove();
				}
				if (!$('.testimonial.placeholder').length) {
					return;
				}
			}

			//remove any unused placeholders
			$('.testimonial.placeholder').remove();

		}).catch((error) => {
			console.log(error)
		});
	}

	function checkWPPlusPosition() {
		var logoPosition = $('.wp-plus-feature .left img').offset().top;
		var scrollPosition = $(window).scrollTop();
		var scrollerLogoPadding = ($('.logo-slider .logo-wrapper').outerHeight() - $('.wp-plus-feature .left img').outerHeight()) / 2;

		if (scrollPosition > (logoPosition - scrollerLogoPadding)) {
			$('.logo-slider').addClass('active');
			$('.wp-plus-feature .left img').addClass('hidden');
		} else {
			$('.logo-slider').removeClass('active');
			$('.wp-plus-feature .left img').removeClass('hidden');
		}

	}

	if ($('.logo-slider').length) {
		checkWPPlusPosition();
		$(window).on('scroll', function() {
			checkWPPlusPosition();
		});
	}

	if ($('#header-video').length) {
		var video = $('#header-video')[0];
		var hls = new Hls();
		let video_id = $(video).data('video-id');
		var video_hls_source = "https://videodelivery.net/" + video_id + "/manifest/video.m3u8";

		if (Hls.isSupported()) {
			hls.loadSource(video_hls_source);
			hls.attachMedia(video);
			video.play();
		} else if (video.canPlayType('application/vnd.apple.mpegURL')) {
			console.error('[0] HLS stream not supported')
			video.src = video_hls_source;
			video.play();
		}
	}

	if ($('.wpplus-video-modal').length) {
		var video = null;
		let modal = $('.wpplus-video-modal');

		$('a[href^="#play-video"]').on('click', function(e) {
			e.preventDefault();

			if ($(this).attr('data-video-id')) {
				video = $('#' + $(this).attr('data-video-id')).find('.cf-player')[0];
				$('#' + $(this).attr('data-video-id')).addClass('active');
				$('#' + $(this).attr('data-video-id')).find('.cf-player').addClass('active');
				$('#' + $(this).attr('data-video-id')).trigger('open');

			} else {

				video = $('.cf-player')[0];
				modal.addClass('active');
				modal.trigger('open');

			}

			let video_id = $(video).data('video-id');

			let hls = new Hls();
			let video_hls_source = "https://videodelivery.net/" + video_id + "/manifest/video.m3u8";

			if (Hls.isSupported()) {
				hls.loadSource(video_hls_source);
				hls.attachMedia(video);
			} else if (video.canPlayType('application/vnd.apple.mpegURL')) {
				console.error('[1] HLS stream not supported')
				video.src = video_hls_source;
			}
		});

		$('a[href^="#close-video"]').on('click', function(e) {
			e.preventDefault();
			console.log('Close video modal click');
			$('body').trigger('modal:close');
		});
	}

	$('.wp-plus-form-button').on('click', function(e) {
		e.preventDefault();
		$('#contact-form-modal').addClass('active');
		$('body').addClass('menu-open');
	});
});

function shuffle(array) {
	let currentIndex = array.length, randomIndex;

	// While there remain elements to shuffle.
	while (currentIndex != 0) {

		// Pick a remaining element.
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;

		// And swap it with the current element.
		[array[currentIndex], array[randomIndex]] = [
			array[randomIndex], array[currentIndex]];
	}

	return array;
}

jQuery(function($) {
	// htmx:beforeRequest
	$('body').on('htmx:beforeRequest', function(evt) {
		// $('body').addClass('showreel-open');
	});

	// If we have a hash in the URL, see if it ends with showreel

	// If it does, open the showreel
	let hash = window.location.hash;

	// Does hash end with showreel?
	if (hash.endsWith('showreel')) {
		// Open the showreel
		if ($(hash).length) {
			htmx.trigger(hash + '>[hx-trigger]', 'openModal');
			// window.location.hash = hash;
		}
	}

	// On pressing escape key, close the showreel
	$('body').on('keydown', function(e) {
		if (e.key === 'Escape') {
			if ($('#modal').length && $('#modal').is(':visible')) {
				htmx.trigger('#modal', 'closeModal');
			}

			if ($('#contact-form-modal').hasClass('active')) {
				$('#contact-form-modal').removeClass('active');
				$('body').removeClass('menu-open');
			}

			if ($('.wpplus-video-modal').length && $('.wpplus-video-modal').is(':visible')) {
				$('body').trigger('modal:close');
			}
		}
	});

	$('#contact-form-modal .close a').on('click', function(e) {
		$('#contact-form-modal').removeClass('active');
		$('body').removeClass('menu-open');
		e.preventDefault();
		e.stopPropagation();
	});

	if ($('.wp-plus-feature').length) {
		$('.wp-plus-feature .feature-images .slides').each(function() {
			var $this = $(this);
			window.setInterval(function() {
				$this.find('.slide:first').appendTo($this);
			}, 2000);
		});
	}
});

function checkforVideo() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	let videoToPlay = urlParams.get('play-video');
	videoToPlay = parseInt(videoToPlay);

	let videosOnPage = $('.cf-player').length;
	// console.log('Videos on page', videosOnPage);

	// Open video modal
	if (videoToPlay && videosOnPage) {
		$('.cf-player').each(function(index, item) {
			// console.log('Checking video', index);
			index = index + 1;

			if (index === videoToPlay) {
				// console.log('Opening video', index);
				let modal = $(item).closest('.wpplus-video-modal');
				// console.log('Opening modal', modal);

				if (modal.length) {
					// console.log('Opening video', index);
					let videoId = $(item).data('video-id');

					// console.log('Video ID', videoId);
					// console.log('Opening modal', modal);
					modal.addClass('active').trigger('open');
					modal.find('.cf-player').attr('data-video-id', videoId);

					playVideoHLS(item, videoId);

					return false;
				} else {
					// console.log('No modal found');
					playVideoHLS(item, $(item).data('video-id'));
				}
			}
		});
	} else if (videosOnPage > 0) {
		$('.cf-player').each(function(index, item) {
			let videoId = $(item).attr('data-video-id');
			// console.log('Video ID', videoId);
			playVideoHLS(item, videoId);
		});
	}
}

jQuery(function($) {
	$('body').on('projects:project-loaded', function(e) {
		checkforVideo();
	});

	checkforVideo();
});

function playVideoHLS(videoPlayer, videoId) {
	if (!videoPlayer || videoPlayer.getAttribute('data-playing') === 'true') {
		console.warn('[playVideoHLS] Video is already playing or element not found.');
		return; // Prevent duplicate play attempts
	}

	if (Hls.isSupported()) {
		const hls = new Hls();
		const videoHLSSource = `https://videodelivery.net/${videoId}/manifest/video.m3u8`;

		hls.attachMedia(videoPlayer);
		hls.on(Hls.Events.MEDIA_ATTACHED, () => {
			hls.loadSource(videoHLSSource);
			hls.on(Hls.Events.MANIFEST_PARSED, () => {
				startVideoPlayback(videoPlayer);
			});
		});
	} else {
		console.error('[playVideoHLS] HLS not supported, using fallback source.');
		videoPlayer.src = `https://videodelivery.net/${videoId}/manifest/video.m3u8`;
		startVideoPlayback(videoPlayer);
	}
}

function startVideoPlayback(videoPlayer) {
	let playPromise = videoPlayer.play();

	if (playPromise !== undefined) {
		playPromise.then(() => {
			console.log('[playVideoHLS] Automatic playback started');
			videoPlayer.setAttribute('data-playing', 'true'); // Mark as playing
		}).catch(error => {
			console.warn('[playVideoHLS] Automatic playback prevented', error);
		});
	}
}

jQuery($ => {
	$('body').on('modal:close', function(el) {
		// console.log('Element', el);
		// console.log('Close video modal');
		let video = null;

		if ($('.wpplus-video-modal.active').length) {
			$('.cf-player.active').removeClass('active');
			// console.log('remove active video class');
			video = $('.cf-player.active')[0];
		} else {
			video = modal.find('video')[0];
		}

		// let video = $('.cf-player.active')[0];
		let modal = $('.wpplus-video-modal.active');
		let otherVideo = modal.find('video');

		// console.log('Video is playing', video);

		$('.wpplus-video-modal').removeClass('active');
		$('.cf-player.active').removeClass('active');
		//get the active video that is playing
		// console.log('remove active video class');

		if (otherVideo.length) {
			otherVideo[0].pause();
		}

		modal.removeClass('active');
		modal.trigger('close');

		video.pause();
		video.currentTime = 0;
	});
	$(window).on('scroll', function() {
		$('section[class^=branding_services]').each(function() {
			$(this).find('em').each(function() {
				//check if this element is past the bottom of the viewport - 4em
				if ($(this).offset().top > $(window).scrollTop() + $(window).height() - 4 * parseFloat($(this).css('font-size'))) {
					$(this).removeClass('active');
				} else {
					$(this).addClass('active');
				}
			});
		});
	});
});
